export type FeatureFlagVariants = 'per-month' | 'per-year';

export const PER_MONTH = 'per-month';
export const PER_YEAR = 'per-year';

export const variants = [PER_MONTH, PER_YEAR] as const;
